import { render, staticRenderFns } from "./checkSROrderLabels.vue?vue&type=template&id=4b58e305&scoped=true&"
import script from "./checkSROrderLabels.vue?vue&type=script&lang=js&"
export * from "./checkSROrderLabels.vue?vue&type=script&lang=js&"
import style0 from "./checkSROrderLabels.vue?vue&type=style&index=0&id=4b58e305&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b58e305",
  null
  
)

component.options.__file = "checkSROrderLabels.vue"
export default component.exports